



























































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class BaseBlock extends Vue {
  /* ---------------- Data ---------------- */
  private name: string = 'BaseBlock';
  private optionLoading: boolean;
  private optionFullscreen: boolean;
  private optionPinned: boolean;
  private optionContentHide: boolean;
  private optionHide: boolean;

  /* ---------------- Props --------------- */
  @Prop({ default: 'div' }) private tag: string;
  @Prop() private title: string;
  @Prop() private subtitle: string;
  @Prop({ default: false }) private bordered: boolean;
  @Prop({ default: false }) private rounded: boolean;
  @Prop({ default: false }) private themed: boolean;
  @Prop({ default: false }) private transparent: boolean;
  @Prop({ default: false }) private fxShadow: boolean;
  @Prop({ default: false }) private fxPop: boolean;
  @Prop({ default: false }) private fxRotateRight: boolean;
  @Prop({ default: false }) private fxRotateLeft: boolean;
  @Prop({ default: false }) private linkShadow: boolean;
  @Prop({ default: false }) private linkPop: boolean;
  @Prop({ default: false }) private linkRotate: boolean;
  @Prop() private headerClass: string;
  @Prop() private optionsClass: string;
  @Prop() private contentClass: string;
  @Prop({ default: false }) private headerBg: boolean;
  @Prop({ default: false }) private headerRtl: boolean;
  @Prop({ default: false }) private contentFull: boolean;
  @Prop({ type: [Boolean], default: false }) private ribbon: [
    boolean
  ];
  @Prop({ default: false }) private ribbonLeft: boolean;
  @Prop({ default: false }) private ribbonBottom: boolean;
  @Prop({ default: false }) private ribbonBookmark: boolean;
  @Prop({ default: false }) private ribbonModern: boolean;
  @Prop({ default: 'primary' }) private ribbonVariant: string;
  @Prop({ default: false }) private modeLoading: boolean;
  @Prop({ default: false }) private modeFullscreen: boolean;
  @Prop({ default: false }) private modePinned: boolean;
  @Prop({ default: false }) private modeContentHide: boolean;
  @Prop({ default: false }) private modeHide: boolean;
  @Prop({ default: false }) private btnOptionFullscreen: boolean;
  @Prop({ default: false }) private btnOptionPinned: boolean;
  @Prop({ default: false }) private btnOptionContent: boolean;
  @Prop({ default: false }) private btnOptionClose: boolean;

  /* ---------------- Computed ------------ */
  get classContainer() {
    return {
      'block-bordered': this.bordered,
      'block-rounded': this.rounded,
      'block-themed': this.themed,
      'block-transparent': this.transparent,
      'block-fx-shadow': this.fxShadow,
      'block-fx-pop': this.fxPop,
      'block-fx-rotate-right': this.fxRotateRight,
      'block-fx-rotate-left': this.fxRotateLeft,
      'block-link-shadow': this.linkShadow,
      'block-link-pop': this.linkPop,
      'block-link-rotate': this.linkRotate,
      'block-mode-loading': this.optionLoading,
      'block-mode-fullscreen': this.optionFullscreen,
      'block-mode-pinned': this.optionPinned,
      'block-mode-hidden': this.optionContentHide,
      'd-none': this.optionHide,
    };
  }

  get classContainerHeader() {
    return {
      'block-header-default': this.headerBg,
      'block-header-rtl': this.headerRtl,
      [this.headerClass]: this.headerClass,
    };
  }

  get classContainerOptions() {
    return {
      [this.optionsClass]: this.optionsClass,
    };
  }

  get classContainerContent() {
    return {
      'block-content-full': this.contentFull,
      'ribbon': this.ribbon,
      'ribbon-left': this.ribbon && this.ribbonLeft,
      'ribbon-bottom': this.ribbon && this.ribbonBottom,
      'ribbon-bookmark': this.ribbon && this.ribbonBookmark,
      'ribbon-modern': this.ribbon && this.ribbonModern,
      [`ribbon-${this.ribbonVariant}`]: this.ribbon && this.ribbonVariant,
      [this.contentClass]: this.contentClass,
    };
  }

  /* ---------------- Methods ------------- */
  private fullscreenToggle() {
    this.optionPinned = false;
    this.optionFullscreen = !this.optionFullscreen;
  }

  private fullscreenOn() {
    this.optionPinned = false;
    this.optionFullscreen = true;
  }

  private fullscreenOff() {
    this.optionPinned = false;
    this.optionFullscreen = false;
  }

  private pinnedToggle() {
    this.optionFullscreen = false;
    this.optionPinned = !this.optionPinned;
  }

  private pinnedOn() {
    this.optionFullscreen = false;
    this.optionPinned = true;
  }

  private pinnedOff() {
    this.optionFullscreen = false;
    this.optionPinned = false;
  }

  private contentToggle() {
    this.optionContentHide = !this.optionContentHide;
  }

  private contentShow() {
    this.optionContentHide = false;
  }

  private contentHide() {
    this.optionContentHide = true;
  }

  private stateToggle() {
    this.optionLoading = !this.optionLoading;
  }

  private stateLoading() {
    this.optionLoading = true;
  }

  private stateNormal() {
    this.optionLoading = false;
  }

  private open() {
    this.optionHide = false;
  }

  private close() {
    this.optionHide = true;
  }

  /* ----------------- Lifecycle Hooks ----------- */
  private $mounted() {
    this.optionLoading = this.modeLoading;
    this.optionFullscreen = this.modeFullscreen;
    this.optionPinned = this.modePinned;
    this.optionContentHide = this.modeContentHide;
    this.optionHide = this.modeHide;
  }
}
